import * as React from "react"

type Props = {
  children: React.ReactNode
  classes?: string
}

const ArticleLayout: React.FC<Props> = ({ children, classes = "" }) => (
  <div className={"grid grid-cols-16 gap-0 " + classes}>
    <div className="col-start-2 col-end-16">{children}</div>
  </div>
)

export default ArticleLayout
